module.exports = __webpack_public_path__ + "static/media/banner_ticket28f723d8fefe6451baa5d66e9db2e44b.webp";